import clsx from 'clsx';
import React from 'react';

import styles from './FormElements.module.scss';

type FormRowProps = {
  className?: string;
  children: React.ReactNode;
  isGrid?: boolean;
  id?: string;
};

export const FormRow: React.FC<FormRowProps> = ({ className, children, isGrid, id }) => (
  <div
    id={id}
    className={clsx(styles.row, className, { [styles.grid]: isGrid })}
  >
    {children}
  </div>
);

type LabelProps = {
  className?: string;
  children?: React.ReactNode;
  id: string;
};

export const FormLabel: React.FC<LabelProps> = ({ className, children, id }) => (
  <div className={clsx(styles.label, className)}>
    <label htmlFor={id}>{children}</label>
  </div>
);

type FormErrorProps = {
  className?: string;
  error: any;
};

export const FormError: React.FC<FormErrorProps> = ({ error, className }) =>
  error ? (
    <div
      id="error"
      className={clsx(styles.error, className)}
    >
      {error}
    </div>
  ) : null;
